import Box from '@zenbusiness/zui/Box';
import CardContent from '@zenbusiness/zui/CardContent';
import Stack from '@zenbusiness/zui/Stack';
import { styled, superstyled } from '@zenbusiness/zui/styles';

const getBackgroundColor = (theme, devbackground, highlight) => {
  if (devbackground) {
    return theme.palette.background.orange.light;
  }

  if (highlight) {
    return theme.palette.background.blue.light;
  }

  return theme.palette.fixed.white;
};

export const NextUpCardContent = superstyled({
  name: 'NextUpCard',
  slot: 'CardContent',
  tag: CardContent,
  propsNeeded: ['devbackground', 'highlight'],
  styles: ({ theme, devbackground, highlight }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
    backgroundColor: getBackgroundColor(theme, devbackground, highlight),
  }),
});

export const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'none',
  width: '5rem',
  backgroundColor: theme.palette.background.blue.light,
  borderRadius: theme.shape.rounded.full,

  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    padding: theme.spacing(1.5),
  },
}));

export const CarrdContainer = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

export const Content = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  justifyContent: 'space-between',
}));
